import { OperatorTypes } from '@avtechsoftware/ra-javascript-utilities/src/types/OperatorTypes';

class BaseFacet {
  constructor() {
    this.displayName = '';
    this.description = '';
  }

  getDisplayName() {
    return this.displayName;
  }

  getDescription() {
    return this.description;
  }

  // eslint-disable-next-line class-methods-use-this,no-unused-vars
  getOperatorDescription(operatorType) {
    const operatorTypeId = parseInt(operatorType, 10);
    const operatorDescriptions = {
      [OperatorTypes.CONTAINS]: 'ANY of the following:',
      [OperatorTypes.CONTAINS_ALL]: 'ALL of the following:',
      [OperatorTypes.NOT_CONTAIN]: 'NONE of the following:',
      [OperatorTypes.EQUAL_TO_VALUE]: '',
      [OperatorTypes.EQUAL_TO_BOOLEAN]: '',
    };
    return operatorDescriptions[operatorTypeId] || '';
  }

  // eslint-disable-next-line class-methods-use-this
  getDisplayValue1(value) {
    return `"${value}"`;
  }

  // eslint-disable-next-line class-methods-use-this
  getDisplayValue2(value) {
    return value;
  }

  // eslint-disable-next-line class-methods-use-this
  fromDisplayValue1(value) {
    return value;
  }

  // eslint-disable-next-line class-methods-use-this
  fromDisplayValue2(value) {
    return value;
  }

  // eslint-disable-next-line class-methods-use-this
  getValueSelectOptions() {
    return [];
  }

  // eslint-disable-next-line class-methods-use-this
  getOperatorSelectOptions() {
    return [];
  }

  // eslint-disable-next-line class-methods-use-this
  getTooltip() {
    return '';
  }
}
export default BaseFacet;
